export default "__VITE_PUBLIC_ASSET__d0d3a819__"